

module.exports = __webpack_require__.stylable.create(
    "dropdowncontent1057325482",
    {"classes":{"root":"dropdowncontent1057325482__root","optionsContainer":"dropdowncontent1057325482__optionsContainer","dropdownOption":"dropdowncontent1057325482__dropdownOption"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    /*! ../node_modules/wix-ui-core/dist/src/components/dropdown-content/DropdownContent.st.css */ 221,
    null
);
